/* Cart behaviour for two hosts that share one body (snippets/crawford-cart-body.liquid):
     drawer  #cdfDrawer, body in #cdfBody,     section crawford-cart       (snippets/custom-cart-drawer.liquid)
     page    #cdfPage,   body in #cdfPageBody, section crawford-cart-page  (sections/crawford-cart-page.liquid, /cart)
   The body is server-rendered on page load and swapped in after every cart change from the host's section:
   bundled with /cart/add.js, /cart/change.js and /cart/update.js, or fetched with ?sections=. One request per
   cart action.
   Kept for code outside the cart:
     window.cdfRefreshCart({ open, loadingMsg })   promo box, add-on popup; on /cart it refreshes the page instead
     [data-open-cart] openers, .js-cart-count badges
     the sticky buy box add (.sticky-buy-box [data-add-to-checkout] button: one item of its data-variant-id,
     with the order-options properties)
   On /cart the drawer is not rendered (snippets/custom-cart-drawer.liquid); everything that touches it returns quietly.
   Empty cart: fillRecent() adds the recently viewed cards (drawer: when an empty body is swapped in while it is open,
   e.g. after the header opener's refresh; /cart on load); their buttons use the add-on handlers. Drawer only:
   removing the last line shows an Undo bar that re-adds it.
   Trustpilot reviews are picked in Liquid (daily seed); nothing here changes them. */
/* Add-on popup (markup: snippets/cart-upsell-popup.liquid). window.openUpsellPopup(upsell[, opener]) fills it from
   the add-on card's own data (nothing is fetched); after an add it closes and calls window.cdfRefreshCart({ open: true }),
   which on /cart refreshes the page instead of opening the drawer. Focus is trapped while open; Escape closes. */
(function(){
  const overlay = document.getElementById('cupOverlay');
  if (!overlay) return;

  const modal    = overlay.querySelector('.cup-modal');
  const closeBtn = document.getElementById('cupClose');
  const imgEl    = document.getElementById('cupImg');
  const nameEl   = document.getElementById('cupName');
  const priceEl  = document.getElementById('cupPrice');
  const pitchEl  = document.getElementById('cupPitch');
  const varWrap  = document.getElementById('cupVariantWrap');
  const varLabel = document.getElementById('cupVariantLabel');
  const varSel   = document.getElementById('cupVariantSelect');
  const atcBtn   = document.getElementById('cupAtc');
  const detailEl = document.getElementById('cupDetails');
  const L = overlay.dataset;

  let opener = null;

  function focusables(){
    return Array.from(modal.querySelectorAll('a[href], button:not([disabled]), select:not([disabled])'))
      .filter(el => el.getClientRects().length && !el.closest('[hidden]'));
  }

  function openPopup(){
    document.body.appendChild(overlay);
    overlay.hidden = false;
    void getComputedStyle(overlay).opacity;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => closeBtn.focus({ preventScroll: true }));
  }

  function closePopup(returnFocus = true){
    if (overlay.hidden) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 210);
    if (returnFocus && opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }

  closeBtn.addEventListener('click', () => closePopup());
  overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', e => {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closePopup(); return; }
    if (e.key !== 'Tab') return;
    const list = focusables(); if (!list.length) return;
    const first = list[0], last = list[list.length - 1];
    if (!modal.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }, true);

  // upsell: { productHandle, title, vendor, image, imageAlt, price, priceLabel, variantId, setupTitle, setupValues,
  //           modelName?, pitch?, url? }   priceLabel: the price already formatted by Liquid (store money format)
  window.openUpsellPopup = async function(upsell, openerEl){
    opener = openerEl || (document.activeElement !== document.body ? document.activeElement : null);
    imgEl.src           = upsell.image || '';
    imgEl.alt           = upsell.imageAlt || upsell.title || '';
    nameEl.textContent  = upsell.modelName || upsell.title || '';
    priceEl.textContent = upsell.priceLabel || '';
    pitchEl.textContent = upsell.pitch || '';
    pitchEl.hidden      = !upsell.pitch;
    detailEl.href       = upsell.url || ('/products/' + (upsell.productHandle || ''));
    atcBtn.disabled     = false;
    atcBtn.textContent  = L.label;
    varWrap.hidden      = true;

    if (upsell.setupValues?.length > 1){
      varLabel.textContent = upsell.setupTitle || '';
      varSel.innerHTML = '';
      upsell.setupValues.forEach((v, i) => { const o = document.createElement('option'); o.value = v; o.textContent = v; if (i === 0) o.selected = true; varSel.appendChild(o); });
      varWrap.hidden = false;
    }

    openPopup();

    atcBtn.onclick = async function(){
      atcBtn.textContent = L.adding;
      atcBtn.disabled    = true;
      const props = {};
      if (!varWrap.hidden && upsell.setupTitle) props[upsell.setupTitle] = varSel.value;
      try {
        const r = await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          credentials:'same-origin',
          body: JSON.stringify({
            id: Number(upsell.variantId),
            quantity: 1,
            ...(Object.keys(props).length && { properties: props })
          })
        });
        if (!r.ok) throw new Error('failed');
        closePopup(false);
        window.cdfRefreshCart?.({ open:true });
      } catch(e){
        console.error('[cup-atc]', e);
        atcBtn.textContent = L.retry;
        atcBtn.disabled    = false;
      }
    };
  };
})();

(() => {
  if (window.__cdfDrawerInit) return;
  window.__cdfDrawerInit = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const DRAWER = { name: 'drawer', el: () => document.getElementById('cdfDrawer'), body: () => document.getElementById('cdfBody'), section: 'crawford-cart', live: 'cdfLive' };
  const PAGE = { name: 'page', el: () => document.getElementById('cdfPage'), body: () => document.getElementById('cdfPageBody'), section: 'crawford-cart-page', live: 'cdfPageLive' };
  const drawerEl = DRAWER.el;
  const backdropEl = () => document.getElementById('cdfBackdrop');
  const onCartPage = () => !!PAGE.el();
  const hostOf = node => (node && node.closest && node.closest('#cdfPage') ? PAGE : DRAWER);
  const text = (host, key) => (host.el()?.dataset[key] || drawerEl()?.dataset[key] || '');

  // ---------- loading / error / announcements (per host) ----------
  const timers = { drawer: {}, page: {} };
  function showLoading(host = DRAWER, { delay = 0 } = {}) {
    const h = host.el(); if (!h) return;
    const t = timers[host.name];
    const spinner = $('.cdf-spinner', h), error = $('.cdf-error', h);
    if (error) error.hidden = true;
    h.classList.add('is-loading-cart');
    clearTimeout(t.spin);
    t.spin = setTimeout(() => { if (spinner) spinner.hidden = false; }, delay);
    clearTimeout(t.watch);
    t.watch = setTimeout(() => hideLoading(host), 15000);
  }
  function hideLoading(host = DRAWER) {
    const h = host.el(); if (!h) return;
    const t = timers[host.name];
    clearTimeout(t.spin); clearTimeout(t.watch);
    const spinner = $('.cdf-spinner', h);
    if (spinner) spinner.hidden = true;
    h.classList.remove('is-loading-cart');
  }
  function showError(host = DRAWER) {
    const h = host.el(); if (!h) return;
    const error = $('.cdf-error', h);
    if (error) { error.textContent = text(host, 'error'); error.hidden = false; }
  }
  function announce(host = DRAWER) {
    const live = document.getElementById(host.live); if (!live) return;
    live.textContent = '';
    setTimeout(() => { live.textContent = text(host, 'updated'); }, 60);
  }

  // ---------- same-day badge (hour before the cutoff, on a listed weekday whose date is not a store holiday,
  //            in the timezone from cart_drawer.same_day_timezone, via data-same-day-tz on the host;
  //            holidays from data-same-day-holidays, YYYY-MM-DD store dates, bad or missing = none) ----------
  function applySameDay(host = DRAWER) {
    const h = host.el(); if (!h) return;
    const badges = $$('[data-same-day="true"]', h);
    if (!badges.length) return;
    const cutoff = parseInt(h.dataset.sameDayCutoff, 10);
    let days = [];
    try { days = JSON.parse(h.dataset.sameDayDays || '[]').map(s => String(s).trim()); } catch (e) {}
    let holidays = [];
    try { holidays = JSON.parse(h.dataset.sameDayHolidays || '[]').map(s => String(s).trim()); } catch (e) { holidays = []; }
    const tz = (h.dataset.sameDayTz || '').trim();
    if (!tz) { badges.forEach(el => { el.hidden = true; }); return; }
    let hour = 0, weekday = '', year = '', month = '', day = '';
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: '2-digit', hourCycle: 'h23', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date())
        .forEach(p => {
          if (p.type === 'hour') hour = parseInt(p.value, 10) || 0;
          if (p.type === 'weekday') weekday = p.value;
          if (p.type === 'year') year = p.value;
          if (p.type === 'month') month = p.value;
          if (p.type === 'day') day = p.value;
        });
    } catch (e) { badges.forEach(el => { el.hidden = true; }); return; }
    const ymd = `${year}-${month}-${day}`;
    const on = !isNaN(cutoff) && hour < cutoff && days.includes(weekday) && !holidays.includes(ymd);
    badges.forEach(el => { el.hidden = !on; });
  }

  // ---------- wallet buttons (drawer only): end of the footer above 600px, end of the scroll area (.cdf-after) on phones ----------
  const mqPhone = window.matchMedia('(max-width: 600px)');
  function placeExpress() {
    const d = drawerEl(); if (!d) return;
    const express = $('.cdf-express', d), foot = $('.cdf-foot', d), after = $('[data-cdf-after]', d);
    if (!express || !foot || !after) return;
    const label = $('.cdf-after__label', after);
    if (mqPhone.matches) {
      if (express.parentElement !== after) after.appendChild(express);
      if (label) label.hidden = false;
    } else {
      if (express.parentElement !== foot) foot.appendChild(express);
      if (label) label.hidden = true;
    }
  }

  mqPhone.addEventListener('change', placeExpress);

  // ---------- body swap ----------
  function syncFromBody(host) {
    const h = host.el(); if (!h) return;
    const body = $('[data-cdf-body]', h); if (!body) return;
    const count = parseInt(body.dataset.itemCount, 10) || 0;
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = count;
      el.toggleAttribute('hidden', !count);
    });
    [DRAWER, PAGE].forEach(h => {
      const countEl = $('[data-cdf-count]', h.el() || document.createElement('div'));
      if (countEl) { countEl.textContent = body.dataset.countLabel || ''; countEl.hidden = !count; }
    });
    // /cart: the page head (title, count, Continue shopping) gives way to the empty block's own h1
    const pageHead = PAGE.el() && $('[data-cdp-head]', PAGE.el());
    if (pageHead) pageHead.hidden = !count;
    if (host === DRAWER) placeExpress();
    applySameDay(host);
    if ($('[data-cdf-recent]', body)) fillRecent(host); else capBest(h);
  }

  function focusables(scope) {
    return $$('a[href], button:not([disabled]), select:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])', scope)
      .filter(el => el.getClientRects().length && !el.closest('[hidden]') && el.getAttribute('aria-hidden') !== 'true');
  }

  const focusHint = { drawer: -1, page: -1 };
  function swap(host, html) {
    const target = host.body(); if (!target || !html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cdf-body]');
    const current = $('[data-cdf-body]', target);
    if (!next) return false;

    // keep keyboard focus at the same position inside the body (focusHint: the control that started
    // this change, recorded before it was disabled, since a disabled button drops focus)
    const active = document.activeElement;
    const live = host === PAGE || isOpen();
    let focusIndex = -1;
    if (current && active && current.contains(active)) focusIndex = focusables(current).indexOf(active);
    if (focusIndex < 0 && focusHint[host.name] > -1 && live && (!active || active === document.body)) focusIndex = focusHint[host.name];
    focusHint[host.name] = -1;
    const scroll = current ? current.scrollTop : 0;

    if (host === DRAWER) undo = null; // any new drawer body ends the undo; changeLine sets it again after a last-line removal
    const imported = document.importNode(next, true);
    if (current) current.replaceWith(imported); else target.appendChild(imported);
    imported.scrollTop = scroll; // the drawer's .cdf-body is its scroll container

    if (focusIndex > -1) {
      const list = focusables(imported);
      const to = list[Math.min(focusIndex, list.length - 1)] || (host === DRAWER && drawerEl() ? $('.cdf-x', drawerEl()) : null);
      to?.focus({ preventScroll: true });
    }
    syncFromBody(host);
    return true;
  }

  async function fetchBody(host = DRAWER) {
    const r = await fetch(`${root}?sections=${host.section}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error('section fetch ' + r.status);
    const json = await r.json();
    if (!swap(host, json[host.section])) throw new Error('section missing');
  }

  // POST to a cart endpoint with the host's section bundled in, then swap it in
  async function cartPost(host, url, payload) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(Object.assign({}, payload, { sections: host.section }))
    });
    const json = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(json.description || json.message || ('cart ' + r.status));
    if (!(json.sections && swap(host, json.sections[host.section]))) await fetchBody(host);
    announce(host);
    return json;
  }

  // ---------- drawer open / close, focus ----------
  let opener = null;
  function isOpen() { return !!drawerEl()?.classList.contains('is-open'); }
  function popupOpen() { const o = document.getElementById('cupOverlay'); return !!(o && !o.hidden); }

  function openDrawer() {
    const d = drawerEl(), b = backdropEl(); if (!d || !b) return;
    if (isOpen()) return;
    opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    d.hidden = false; b.hidden = false;
    void d.offsetWidth;
    d.classList.add('is-open'); b.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    // lock the page behind the drawer (on <html>: the add-on popup locks and unlocks <body>, so the two never undo each other)
    document.documentElement.style.overflow = 'hidden';
    applySameDay(DRAWER);
    requestAnimationFrame(() => $('.cdf-x', d)?.focus({ preventScroll: true }));
  }

  function closeDrawer() {
    drawerEl()?.classList.remove('is-adding');
    const d = drawerEl(), b = backdropEl(); if (!d || !b) return;
    if (!isOpen()) return;
    closeNote(false);
    undo = null;
    const undoBar = $('[data-cdf-undo]', d);
    if (undoBar) undoBar.hidden = true;
    d.classList.remove('is-open'); b.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(() => { if (!isOpen()) b.hidden = true; }, 180);
    setTimeout(() => { if (!isOpen()) d.hidden = true; }, 220); // after the slide-out
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }

  document.addEventListener('keydown', e => {
    if (!isOpen() || popupOpen()) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      if (noteIsOpen()) closeNote(true); else closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    const scope = noteIsOpen() ? $('.cdf-note-panel', drawerEl()) : drawerEl();
    const list = focusables(scope);
    if (!list.length) return;
    const first = list[0], last = list[list.length - 1];
    if (!scope.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- global refresh (same signature as before; on /cart it refreshes the page, never opens the drawer) ----------
  async function cdfRefreshCart({ open = false } = {}) {
    const host = onCartPage() ? PAGE : DRAWER;
    if (open && host === DRAWER) openDrawer();
    showLoading(host);
    try { await fetchBody(host); announce(host); }
    catch (err) { console.error('[cart] refresh', err); showError(host); }
    finally { hideLoading(host); }
  }
  window.cdfRefreshCart = cdfRefreshCart;

  // ---------- drawer order note (slide-up panel) ----------
  function noteIsOpen() { return !!document.getElementById('cdfNoteOverlay')?.classList.contains('is-open'); }
  function openNote() {
    const overlay = document.getElementById('cdfNoteOverlay');
    const textarea = document.getElementById('cdfNoteTextarea');
    if (!overlay || !drawerEl()) return;
    if (textarea) textarea.value = $('[data-cdf-body]', drawerEl())?.dataset.note || '';
    overlay.hidden = false; void overlay.offsetWidth;
    overlay.classList.add('is-open');
    setTimeout(() => textarea?.focus({ preventScroll: true }), 60);
  }
  function closeNote(returnFocus) {
    const overlay = document.getElementById('cdfNoteOverlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    setTimeout(() => { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 250);
    if (returnFocus && drawerEl()) $('[data-cdf-note-toggle]', drawerEl())?.focus({ preventScroll: true });
  }
  async function saveNote() {
    const textarea = document.getElementById('cdfNoteTextarea');
    const btn = document.getElementById('cdfNoteSave');
    if (!textarea) return;
    if (btn) btn.disabled = true;
    showLoading(DRAWER, { delay: 200 });
    try { await cartPost(DRAWER, `${root}cart/update.js`, { note: textarea.value }); closeNote(true); }
    catch (err) { console.error('[cart-note] save', err); showError(DRAWER); }
    finally { if (btn) btn.disabled = false; hideLoading(DRAWER); }
  }

  // ---------- page order note (inline) ----------
  function togglePageNote(btn) {
    const panel = document.getElementById(btn.getAttribute('aria-controls')); if (!panel) return;
    const open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open) $('textarea', panel)?.focus();
  }
  async function savePageNote(btn) {
    const textarea = $('#cdpNoteText', PAGE.el()); if (!textarea) return;
    btn.disabled = true;
    showLoading(PAGE, { delay: 200 });
    try { await cartPost(PAGE, `${root}cart/update.js`, { note: textarea.value }); }
    catch (err) { console.error('[cart-note] save', err); showError(PAGE); btn.disabled = false; }
    finally { hideLoading(PAGE); }
  }

  // ---------- line quantity / remove ----------
  // memo (drawer only): { id, quantity, properties, title } of the only remaining line, when this removes it
  async function changeLine(host, key, quantity, memo = null) {
    showLoading(host);
    try {
      await cartPost(host, `${root}cart/change.js`, { id: key, quantity });
      if (memo && host === DRAWER) showUndo(memo);
    }
    catch (err) { console.error('[cart] change', err); showError(host); }
    finally { hideLoading(host); }
  }

  // ---------- undo the last-line removal (drawer only; cleared on close and by any other cart change) ----------
  let undo = null;
  function showUndo(memo) {
    const body = drawerEl() && $('[data-cdf-body]', drawerEl());
    if (!body || (parseInt(body.dataset.itemCount, 10) || 0) !== 0) return;
    const bar = $('[data-cdf-undo]', body), empty = $('[data-cdf-empty]', body);
    if (!bar) return;
    const span = $('span', bar);
    if (span) span.textContent = (empty?.dataset.removedLabel || '').replace('{{ title }}', memo.title);
    bar.hidden = false;
    undo = memo;
    if (body.contains(document.activeElement) || document.activeElement === document.body) $('[data-cdf-undo-btn]', bar)?.focus({ preventScroll: true });
  }
  async function undoRemove(btn) {
    const memo = undo; undo = null;
    if (!memo) return;
    btn.disabled = true;
    showLoading(DRAWER);
    try {
      await cartPost(DRAWER, `${root}cart/add.js`, Object.assign(
        { id: memo.id, quantity: memo.quantity },
        Object.keys(memo.properties).length ? { properties: memo.properties } : {}
      ));
    } catch (err) { console.error('[cart] undo', err); showError(DRAWER); btn.disabled = false; }
    finally { hideLoading(DRAWER); }
  }

  // ---------- recently viewed in the empty cart ----------
  // localStorage cfs_rv (read only; snippets/recently-viewed-recorder.liquid writes it): [{ h: handle, f: family }],
  // newest first. Up to data-max × 2 handles are fetched as /products/<handle>?view=cart-recent
  // (templates/product.cart-recent.liquid: one li.cdf-addon--recent, nothing when unavailable); the first data-max
  // cards in list order are kept. Whatever arrived within 3 seconds is used, once per page view.
  const recentCache = {};
  function loadRecent(max) {
    if (recentCache[max]) return recentCache[max];
    let list = null;
    try { list = JSON.parse(localStorage.getItem('cfs_rv')); } catch (e) {}
    if (!Array.isArray(list)) return (recentCache[max] = Promise.resolve([]));
    const entries = list.filter(x => x && typeof x.h === 'string' && x.h).slice(0, max * 2);
    if (!entries.length) return (recentCache[max] = Promise.resolve([]));
    const ctrl = window.AbortController ? new AbortController() : null;
    const found = new Array(entries.length).fill(null);
    const requests = entries.map((x, i) =>
      fetch(`${root}products/${encodeURIComponent(x.h)}?view=cart-recent`, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(r => (r.ok && r.status === 200 ? r.text() : ''))
        .then(html => {
          if (!html || !html.trim()) return;
          const tpl = document.createElement('template');
          tpl.innerHTML = html;
          const card = tpl.content.querySelector('li.cdf-addon--recent');
          if (card) found[i] = card.outerHTML;
        })
        .catch(() => {})
    );
    let timer;
    const timeout = new Promise(resolve => { timer = setTimeout(() => { if (ctrl) ctrl.abort(); resolve(); }, 3000); });
    return (recentCache[max] = Promise.race([Promise.all(requests), timeout])
      .then(() => { clearTimeout(timer); return found.filter(Boolean).slice(0, max); }));
  }
  // /cart best-sellers: only the first 4 cards not hidden show. The CSS :nth-child(… of …) rule does this where
  // supported; older browsers need the hidden attribute. Cards hidden here are marked so a later pass can undo it.
  function capBest(h) {
    const cards = $$('.cdp-best .cdp-cards > *', h);
    cards.forEach(card => { if (card.dataset.cdfCapped) { card.hidden = false; delete card.dataset.cdfCapped; } });
    cards.filter(card => !card.hidden).slice(4).forEach(card => { card.hidden = true; card.dataset.cdfCapped = 'true'; });
  }
  async function fillRecent(host) {
    const h = host.el(); if (!h) return;
    capBest(h);
    if (host === DRAWER && !isOpen()) return; // the drawer fetches on first open, not on every page load
    const box = $('[data-cdf-recent]', h);
    if (!box || box.dataset.filled) return;
    box.dataset.filled = 'true';
    const max = parseInt(box.dataset.max, 10) || 0;
    if (max < 1) return;
    const cards = await loadRecent(max);
    if (!cards.length || !box.isConnected) return; // nothing arrived: the first-visit state stays as rendered
    const tpl = document.createElement('template');
    tpl.innerHTML = cards.join('');
    // the card is fetched once for both hosts: set this host's image sizes and Add label
    $$('.cdf-addon__media img', tpl.content).forEach(img => { if (box.dataset.imgSizes) img.sizes = box.dataset.imgSizes; });
    $$('[data-cdf-addon-add]', tpl.content).forEach(btn => { if (box.dataset.addLabel) btn.textContent = box.dataset.addLabel; });
    const shown = new Set($$('[data-cdf-addon]', tpl.content).map(c => c.dataset.handle));
    $('.cdf-recent', box)?.replaceChildren(tpl.content);
    box.hidden = false;
    const empty = box.closest('[data-cdf-empty]') || h;
    $$('[data-cdf-when]', empty).forEach(el => { el.hidden = el.dataset.cdfWhen !== 'recent'; });
    $('[data-cdf-empty-cta]', empty)?.classList.add('cdf-btn--ghost');
    const browse = $('[data-cdf-browse-label]', empty);
    if (browse && empty.dataset.orBrowseLabel) browse.textContent = empty.dataset.orBrowseLabel;
    // /cart: best-sellers cards already shown under Recently viewed are hidden, then the first 4 left show
    $$('.cdp-best [data-handle]', h).forEach(card => { if (shown.has(card.dataset.handle)) { card.hidden = true; delete card.dataset.cdfCapped; } });
    capBest(h);
  }

  // ---------- add-ons ----------
  function upsellFrom(card) {
    const ds = card.dataset;
    let setupValues = [];
    try { setupValues = JSON.parse(ds.setupValues || '[]'); } catch (e) {}
    const extra = $('template[data-cdf-addon-extra]', card)?.content;
    return {
      productHandle: ds.handle,
      title: ds.title,
      vendor: ds.vendor,
      image: ds.image,
      imageAlt: ds.imageAlt,
      price: parseInt(ds.price, 10) || 0,
      priceLabel: ds.priceLabel || '',
      variantId: ds.variantId,
      setupTitle: ds.setupTitle,
      setupValues,
      pitch: ds.pitch || '',
      url: ds.url || '',
      modelName: (extra && extra.querySelector('[data-model-name]')?.textContent || '').trim()
    };
  }
  async function addAddon(host, card, btn) {
    const upsell = upsellFrom(card);
    const select = $('.cdf-addon__select', card);
    const properties = select ? { [upsell.setupTitle]: select.value } : {};
    btn.disabled = true;
    showLoading(host);
    try {
      await cartPost(host, `${root}cart/add.js`, Object.assign(
        { id: Number(upsell.variantId), quantity: 1 },
        Object.keys(properties).length ? { properties } : {}
      ));
    } catch (err) {
      console.error('[upsell-add]', err);
      showError(host);
      btn.disabled = false;
    } finally { hideLoading(host); }
  }

  // ---------- delegated clicks inside either host (the body is replaced on every change) ----------
  document.addEventListener('click', e => {
    const t = e.target; if (!t || !t.closest) return;
    if (t.id === 'cdfBackdrop') { closeDrawer(); return; }
    if (!t.closest('#cdfDrawer, #cdfPage')) return;
    const host = hostOf(t);
    const body = $('[data-cdf-body]', host.el());
    const control = t.closest('button, a, select');
    focusHint[host.name] = body && control && body.contains(control) ? focusables(body).indexOf(control) : -1;
    if (host === DRAWER) {
      if (t.closest('[data-cdf-close]')) { closeDrawer(); return; }
      if (t.closest('[data-cdf-note-toggle]')) { openNote(); return; }
      if (t.closest('[data-cdf-note-close]')) { closeNote(true); return; }
      if (t.closest('#cdfNoteSave')) { saveNote(); return; }
      const ub = t.closest('[data-cdf-undo-btn]'); if (ub) { undoRemove(ub); return; }
    } else {
      const nt = t.closest('[data-cdf-pnote-toggle]'); if (nt) { togglePageNote(nt); return; }
      const ns = t.closest('[data-cdf-pnote-save]'); if (ns) { savePageNote(ns); return; }
    }
    const qty = t.closest('[data-cdf-qty]');
    if (qty) {
      const line = qty.closest('[data-key]');
      if (!line) return;
      const quantity = Math.max(0, parseInt(qty.dataset.cdfQty, 10) || 0);
      // drawer: removing the only remaining line (cart count = its quantity) remembers it for Undo
      let memo = null;
      const lineQty = parseInt($('.cdf-qty__num', line)?.textContent, 10) || 0;
      if (host === DRAWER && quantity === 0 && body && lineQty > 0 && (parseInt(body.dataset.itemCount, 10) || 0) === lineQty) {
        let properties = {};
        try { properties = JSON.parse(line.dataset.properties || '{}') || {}; } catch (e) {}
        memo = { id: Number(line.dataset.variantId), quantity: lineQty, properties, title: line.dataset.title || '' };
      }
      changeLine(host, line.dataset.key, quantity, memo);
      return;
    }
    const card = t.closest('[data-cdf-addon]');
    if (card && t.closest('[data-cdf-addon-open]')) { window.openUpsellPopup?.(upsellFrom(card), t.closest('[data-cdf-addon-open]')); return; }
    const add = t.closest('[data-cdf-addon-add]');
    if (card && add) addAddon(host, card, add);
  });

  // ---------- header & mobile cart openers ----------
  // Open at once with the server-rendered body, then refresh it (another script may have just added to the cart).
  // On /cart the page is the cart: the icon scrolls to the top instead of opening the drawer.
  async function openAndRefresh() {
    openDrawer();
    showLoading(DRAWER, { delay: 300 });
    try { await fetchBody(DRAWER); }
    catch (err) { console.error('[cart-drawer] load', err); showError(DRAWER); }
    finally { hideLoading(DRAWER); }
  }
  $$('[data-open-cart]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      if (onCartPage()) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      openAndRefresh();
    });
  });

  // ---------- sticky buy box CTA ----------
  // The main button is a <button> (snippets/product-hero-cta.liquid) carrying data-variant-id; one item is added,
  // with the order-options properties. Other scripts (sticky bar, gift cards, promo line) trigger it with .click().
  // From an empty cart the drawer gets .is-adding while the add is in flight, so the stale empty state (and its
  // lazy images) stays hidden under the spinner.
  const sbbBtn = document.querySelector('.sticky-buy-box [data-add-to-checkout]');
  if (sbbBtn) {
    async function addFromBuyBox(e) {
      e.preventDefault();

      // Required order-options prompts (snippets/order-options.liquid) must
      // block the add — there is no native <form> here to call
      // reportValidity() on, so validate each select individually.
      if (window.CFS?.orderOptions && !window.CFS.orderOptions.validateAndReport()) {
        return;
      }

      const variantId = sbbBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      const d = drawerEl();
      if (d && parseInt($('[data-cdf-body]', d)?.dataset.itemCount, 10) === 0) d.classList.add('is-adding');
      openDrawer(); showLoading(DRAWER);

      try {
        const properties = window.CFS?.orderOptions?.collect() || {};
        const requestBody = Object.assign(
          { id: Number(variantId), quantity: 1 },
          Object.keys(properties).length ? { properties } : {}
        );
        await cartPost(DRAWER, `${root}cart/add.js`, requestBody);
      } catch (err) {
        console.error('Add to cart error', err);
        showError(DRAWER);
      } finally {
        hideLoading(DRAWER);
        drawerEl()?.classList.remove('is-adding');
      }
    }
    sbbBtn.addEventListener('click', addFromBuyBox);
  }

  applySameDay(DRAWER);
  if (onCartPage()) { applySameDay(PAGE); fillRecent(PAGE); }
})();
